const DEFAULT_LOCALE = { code: "pt-BR", currency: "BRL" }

function processInput(inputValue) {
    if (inputValue == null || Number.isNaN(inputValue)) return null
    return Number(inputValue)
}

export function fCurrency(inputValue, options) {
    const locale = DEFAULT_LOCALE

    const number = processInput(inputValue)
    if (number === null) return ""

    const fm = new Intl.NumberFormat(locale.code, {
        style: "currency",
        currency: locale.currency,
        ...options,
    }).format(number)

    return fm
}
